module.exports = __webpack_public_path__ + "img/img13.18b34829.svg";